// removed by extract-text-webpack-plugin
module.exports = {"themeSlider":"themeSlider__1fyiG","closeSlider":"closeSlider__3FmcD","headingWrapper":"headingWrapper__20q-Z","year":"year__389MQ","countryName":"countryName__3EIN6","scrollSection":"scrollSection__1onOX","theme_slider_wrapper":"theme_slider_wrapper__1GxNP","theme_slider_title":"theme_slider_title__29eoz","grouped_bar_chart":"grouped_bar_chart__3i_aH","per_bar_chart":"per_bar_chart__SPeML","summarySection":"summarySection__2x0RN","summaryDetails":"summaryDetails__1x8fB","summaryHeading":"summaryHeading__3rPGU","imageWrapper":"imageWrapper__2J5LB","sdg_image":"sdg_image__2X-iu"};


//////////////////
// WEBPACK FOOTER
// ./components/sdgSlider/style.scss
// module id = 5iAr
// module chunks = 0 1